import * as React from 'react'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'

import Cols from 'modules/app_store/components/Cols'
import useFetchData from 'modules/app_store/hooks/useFetchData'
import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'

import Sidebar from './Sidebar'
import styles from './index.module.scss'

interface Props {
  children: React.ReactNode
}

const Apps = ({ children }: Props) => {
  const { loading } = useFetchData('')

  if (loading) return <Loading />

  return <div className={styles.lists}>{children}</div>
}

const AppsListWrapper = ({ children }: Props) => (
  <Page>
    <Page.Header>
      <Header.Title>{i18n.t('app_store_v2.common.apps')}</Header.Title>
    </Page.Header>
    <Page.Body>
      <Cols>
        <Sidebar />
        <Apps>{children}</Apps>
      </Cols>
    </Page.Body>
  </Page>
)

export default AppsListWrapper
